import { render, staticRenderFns } from "./SpinnerButton.vue?vue&type=template&id=6f56e1b6&scoped=true"
import script from "./SpinnerButton.vue?vue&type=script&lang=js"
export * from "./SpinnerButton.vue?vue&type=script&lang=js"
import style0 from "./SpinnerButton.vue?vue&type=style&index=0&id=6f56e1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f56e1b6",
  null
  
)

export default component.exports